import { render } from "./Chat.svg?vue&type=template&id=9e89a794"
const script = {}
script.render = render

export default script